<div [id]="id" class="row solid-section solid-section__slide">
  <div class="col-12 px-0">
      <div class="col-12 justify-content-center section__slide-title">{{ block.blockTitle }}</div>
      <div class="swiper swiper--slides px-3 px-md-5" #swiper>
        <div class="swiper-wrapper">
          <div *ngFor="let slide of slides; let i = index; let len = count" class="swiper-slide">
            <img class="swiper-slide__image w-100" [src]="slide.imageUrl" [alt]="slide.name">
          </div>
        </div>
        <div class="swiper-button-next" [ngClass]="id">
            <img class="image" src="/images/svg/event-page/right-arrow-circle.svg">
        </div>
        <div class="swiper-button-prev" [ngClass]="id">
            <img class="image" src="/images/svg/event-page/left-arrow-circle.svg">
        </div>
      </div>
  </div>
</div>
